import axiosService from "../../util/axiosService";
import { ACCION } from "../../util/directory.js";
import {
  SHOW_TEXT,
  RESPONSE_ERROR,
  MEDICATION_CURRENT,
  MEDICATION_EDITED,
  MEDICATION_CREATED,
  MEDICATION_SEARCHED,
  MEDICATION_SEARCH_REALIZED,
} from "../_types/medicationType";
import { PAGINATION } from "../_types/paginationType";
import { catchErrorNetwork } from "../../util/stringer";

let { url_x_medicacion_persona } = require("../../configs/Ambiente.json")[
  "urls"
];

export const setShowText = (text) => async (dispatch) => {
  dispatch({ type: SHOW_TEXT, payload: text });
  dispatch({ type: RESPONSE_ERROR, payload: false });
};

export const setMedicationWasCreated = (isValid) => async (dispatch) => {
  dispatch({
    type: MEDICATION_CREATED,
    payload: isValid,
  });
};

export const setMedicationWasEdited = (isValid) => async (dispatch) => {
  dispatch({
    type: MEDICATION_EDITED,
    payload: isValid,
  });
};

export const getMedication =
  (id_medicacion_persona_clinica) => async (dispatch) => {
    let body = { typeAccion: ACCION.OBTENER_ID, id_medicacion_persona_clinica };
    axiosService({
      type: "post",
      url: url_x_medicacion_persona,
      body,
      success: (res) => {
        let { isSuccess, error, results } = res.data;
        if (isSuccess) {
          if (!error) {
            dispatch({ type: MEDICATION_CURRENT, payload: results[0] });
            dispatch({ type: SHOW_TEXT, payload: "" });
            dispatch({ type: RESPONSE_ERROR, payload: false });
          } else {
            dispatch({ type: MEDICATION_CURRENT, payload: [] });
            dispatch({ type: SHOW_TEXT, payload: error });
            dispatch({ type: RESPONSE_ERROR, payload: true });
          }
        } else {
          dispatch({ type: MEDICATION_CURRENT, payload: [] });
          dispatch({ type: SHOW_TEXT, payload: error });
          dispatch({ type: RESPONSE_ERROR, payload: true });
        }
      },
      fail: (err) => {
        dispatch({ type: MEDICATION_CURRENT, payload: [] });
        dispatch({ type: SHOW_TEXT, payload: catchErrorNetwork(null, err) });
        dispatch({ type: RESPONSE_ERROR, payload: true });
      },
    });
  };

export const setSerchRealized = (value) => async (dispatch) => {
  dispatch({ type: MEDICATION_SEARCH_REALIZED, payload: value });
};

export const getMedicationSearched =
  (chain, page, limit, id_usuario) => async (dispatch) => {
    //chain = !chain ? "&&" : chain;
    let body = {
      typeAccion: ACCION.BUSCAR,
      data: chain,
      page,
      limit,
      id_usuario,
    };
    axiosService({
      type: "post",
      url: url_x_medicacion_persona,
      body,
      success: (res) => {
        let { isSuccess, error, results, total } = res.data;
        if (!isSuccess) {
          if (error.length >= 0) {
            dispatch({ type: PAGINATION, payload: { page: 1, total: 0 } });
            dispatch({ type: MEDICATION_SEARCHED, payload: [] });
            dispatch({ type: MEDICATION_SEARCH_REALIZED, payload: true });
            dispatch({ type: RESPONSE_ERROR, payload: true });
            dispatch({ type: SHOW_TEXT, payload: error });
          }
          return;
        }

        dispatch({ type: PAGINATION, payload: { page: page, total: total } });
        dispatch({ type: MEDICATION_SEARCHED, payload: results });
        dispatch({ type: MEDICATION_SEARCH_REALIZED, payload: true });
        dispatch({ type: RESPONSE_ERROR, payload: false });
        dispatch({ type: SHOW_TEXT, payload: "" });
      },
      fail: (err) => {
        dispatch({ type: PAGINATION, payload: { page: 1, total: 0 } });
        dispatch({ type: MEDICATION_SEARCHED, payload: [] });
        dispatch({ type: MEDICATION_SEARCH_REALIZED, payload: true });
        dispatch({ type: RESPONSE_ERROR, payload: true });
        dispatch({ type: SHOW_TEXT, payload: "Error de conexión" });
      },
    });
  };

export const createMedication = (data) => async (dispatch) => {
  let body = { typeAccion: ACCION.CREAR, ...data };
  axiosService({
    type: "post",
    url: url_x_medicacion_persona,
    body,
    success: (res) => {
      let { isSuccess, error, results, statusCode } = res.data;
      if (isSuccess && !error) {
        dispatch({ type: MEDICATION_CREATED, payload: true });
        dispatch({ type: MEDICATION_CURRENT, payload: results[0] });
        dispatch({ type: RESPONSE_ERROR, payload: false });
        dispatch({
          type: SHOW_TEXT,
          payload: `El medicamento administrado fue creado`,
        });
      } else {
        dispatch({ type: SHOW_TEXT, payload: error });
        dispatch({ type: RESPONSE_ERROR, payload: true });
      }
    },
    fail: (err) => {
      dispatch({ type: SHOW_TEXT, payload: "Error de conexión" });
      dispatch({ type: RESPONSE_ERROR, payload: true });
    },
  });
};

export const editMedication = (data) => async (dispatch) => {
  let body = { typeAccion: ACCION.MODIFICAR, ...data };
  axiosService({
    type: "post",
    url: url_x_medicacion_persona,
    body,
    success: (res) => {
      let { isSuccess, error, results } = res.data;
      if (isSuccess && !error) {
        dispatch({ type: MEDICATION_EDITED, payload: true });
        dispatch({ type: MEDICATION_CURRENT, payload: results[0] });
        dispatch({ type: RESPONSE_ERROR, payload: false });
        dispatch({
          type: SHOW_TEXT,
          payload: `El medicamento administrado ha sido actualizado`,
        });
      } else {
        dispatch({ type: SHOW_TEXT, payload: error });
        dispatch({ type: RESPONSE_ERROR, payload: true });
      }
    },
    fail: (err) => {
      dispatch({ type: SHOW_TEXT, payload: "Error de conexión" });
      dispatch({ type: RESPONSE_ERROR, payload: true });
    },
  });
};

// export const deleteUserInCreation =
//   (id_usuario, msgSuccess) => async (dispatch) => {
//     axiosService({
//       type: "post",
//       url: url_post_user,
//       body: { typeAccion: ACCION.BORRAR, id_usuario: id_usuario },
//       success: (res) => {
//         let { isSuccess, error, results, statusCode } = res.data;
//         if (isSuccess && !error) {
//           if (msgSuccess) {
//             dispatch({ type: SHOW_TEXT, payload: msgSuccess });
//             dispatch({ type: RESPONSE_ERROR, payload: true });
//           } else {
//             dispatch({ type: SHOW_TEXT, payload: results });
//             dispatch({ type: RESPONSE_ERROR, payload: false });
//           }
//         } else {
//           dispatch({
//             type: SHOW_TEXT,
//             payload: catchErrorNetwork(statusCode, JSON.stringify(error)),
//           });
//           dispatch({ type: RESPONSE_ERROR, payload: true });
//         }
//       },
//       fail: (err) => {
//         dispatch({ type: SHOW_TEXT, payload: "Error de conexión" });
//         dispatch({ type: RESPONSE_ERROR, payload: true });
//       },
//     });
//   };
